<div class="p-2">
    <h1 mat-dialog-title>Activate Embedded Organization</h1>
    <div mat-dialog-content [formGroup]="formControl">
        <div class="row justify-content-between mt-4">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Organization ID</mat-label>
                    <input matInput placeholder="Organization ID" formControlName="organization_id" readonly>
                </mat-form-field>
                <mat-error *ngIf="!formControl.controls['organization_id'].value"></mat-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Organization Name</mat-label>
                    <input matInput placeholder="Organization Name" formControlName="organization_name" readonly>
                </mat-form-field>
                <mat-error *ngIf="!formControl.controls['organization_name'].value"></mat-error>
            </div>
        </div>
        <div class="row justify-content-between mt-1">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Partner</mat-label>
                    <input matInput placeholder="PMS" formControlName="pms" readonly>
                </mat-form-field>
                <mat-error *ngIf="!formControl.controls['pms'].value"></mat-error>
            </div>
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Partner ID</mat-label>
                    <input matInput placeholder="Partner ID" formControlName="partner_id" readonly>
                </mat-form-field>
                <mat-error *ngIf="!formControl.controls['partner_id'].value"></mat-error>
            </div>
        </div>
        <div class="row justify-content-between mt-1">
            <div class="col-lg-6 col-12 d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Activation Date <span class="red">*</span></mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="activation_date" (dateChange)="onActivationDateChange($event)" [max]="maxDate" [min]="minDate" readonly>
                    <mat-error *ngIf="!formControl.get('activation_date')?.value">Required</mat-error>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div *ngIf="showConfirmationCheckbox" class="my-3">
        <mat-checkbox class="checkbox" (change)="onConfirmCheckboxChange($event)">
            <span class="checkbox-text">
                All Reservations may not be covered due to Activation Date.<br>Please confirm you would like to continue.
            </span>
        </mat-checkbox>
    </div>
    <div class="mx-4 d-flex justify-content-end">
        <span class="red">*</span>&nbsp;- Required fields
    </div>
    <mat-dialog-actions class="mt-3 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCloseClick()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="onSaveClick()" [disabled]="!formControl.valid || !confirmSubmit">
            <mat-icon>check</mat-icon>
            Submit
        </button>
    </mat-dialog-actions>
</div>